import { Heading, Text, Flex } from '@chakra-ui/react'
import React from 'react'
import PageWrapper from '../Common/PageWrapper'

const HistoryPage: React.FC = () => {
  return (
    <PageWrapper>
      <Heading mb={12}>Vetaraanitalon historiaa</Heading>
      <Flex maxW='1200px' direction='column'>
        <Heading fontSize='xl' mb={2}>
          1. Alkuvaiheet
        </Heading>
        <Text mb={2}>
          Kauhavalaisen JR 23 4.komppanian päällikkö luutnantti Yrjö Haavisto
          kaatui talvisodassa 24.12.39. Ajatus Haaviston perheelle hankittavasta
          ns. asevelitalosta virisi JR 58 aseveljien keskuudessa alkutalvella
          1943. Niinpä kauhavalaiset aseveljet Toivo Laitila, Sulo Lindqvist,
          Veikko Jylhä, Aarne Tuomaala, Eero Kari ja Arvi Viitala saivat
          komennuksen Terijoelle, jossa oli käynnistynyt useamman asevelitalon
          veistotyöt. Talon suunnitelmat laati alahärmäläissyntyinen
          rakennusmestari Toivo M. Ala-Huhta. Talo oli kooltaan 7,5m x 9.5m ja
          sisälsi kaksi huonetta ja keittiön.
        </Text>
        <Text mb={2}>
          Toivo Laitila muisteli, että työ eteni hitaanlaisesti, koska miehiä ei
          valittu ammattitaidon mukaan. Eversti Haanterä huomautti
          tarkastuskäynnillään hitaanlaisesta vauhdista, mutta oli tyytyväinen
          työn hyvään laatuun. Kolmen kuukauden uurastuksen jälkeen talo oli
          saatu tasakertaan ja niinpä juhannuksen 1943 tienoilla saatiin ihailla
          Haukijärven rannalla seisovaa uljasta pirttiä. Hirret numeroitiin,
          kuormattiin rautatievaunuun ja lähetettiin Kauhavalle. Kauhavalla
          aseveliyhdistyksen vanhemmat miehet huolehtivat talon uudelleen
          kokoamisesta ja muista rakennustöistä. Talo pystytettiin Kirkkotien
          päässä olevalle tontille.
        </Text>
        <Heading fontSize='xl' mb={2} mt={4}>
          2. Haaviston perheen uusi koti
        </Heading>
        <Text mb={2}>
          Niinpä ennen talven tuloa 1943 sotaleski Senja Haavisto pääsi neljän
          lapsensa kanssa muuttamaan oman kodin orren alle. Perhe asui talossa
          1950-luvun puoliväliin saakka. Lapset muuttivat vuosien myötä yksi
          toisensa jälkeen pääkaupunseudulle ja siksi Senja-äitikin muutti
          lasten tavoin Helsinkiin. Hän myi omistamansa kiinteistön apteekkari
          Kyllikki Luomalle, joka taas myi sen edelleen rakennusmestari Matti
          Virrankoskelle keväällä 1989.
        </Text>
        <Heading fontSize='xl' mb={2} mt={4}>
          3. Veteraanitaloksi
        </Heading>
        <Text mb={2}>
          Kauhavan veteraaniyhdistys sai tietoonsa, että Matti Virrankoski aikoo
          purkaa talon. Sen johdosta yhdistys otti yhteyttä häneen ja
          neuvottelujen tuloksena Matti Virrankoski lahjoitti talon
          yhdistykselle poissiirrettäväksi.
        </Text>
        <Text mb={2}>
          Syskuussa 1989 yhdistyksen hallitus nimesi rakennustoimikunnan, johon
          valittiin Pentti Tammela puheenjohtajaksi ja jäseniksi Eino Häjänen,
          Antti Passi ja Martti Mansikkamäki. Toimikunta löysi sopivan,
          Kauhava-seuran omistaman tontin Kosolanmäeltä. Talon siirto uuteen
          paikkaan alkoi vauhdilla. Kaikki työ tehtiin talkoovoimin. Purkutyö
          saatiin tehtyä 26.9.89, laatan valu tehtiin 25.10.89 ja kehikon
          rakennustyö alkoi 3.11.89 ja se saatiin vesikattovaiheeseen 11.11.89.
          Harjakaisia vietettiin 22.11.89, jonka jälkeen rakennustyö jätettiin
          talvilepoon. Seuraavana keväänä työ jatkui toukokuulla ja talo oli
          kokonaisuudessaan valmis 30.9.1990.
        </Text>
        <Heading fontSize='xl' mb={2} mt={4}>
          4. Talkootyön voima
        </Heading>
        <Text mb={2}>
          Talon siirron talkootyöhön osallistui kaikkiaan 120 veteraaniveljeä-ja
          sisarta. Talkoopäiviä tehtiin 3 päivää viikossa yhteensä 80 päivänä.
          Kokonaisuudessaan työpäiviä yhteenlaskettuna kertyi yli 900. Tavara-ja
          raha-apua saatiin yli 100 yksityiseltä henkilöltä ja yhteisöltä.
          Yhdistys onnistui toteuttamaan hankkeen kalustusta myöten ilman
          velkarahaa.
        </Text>
        <Text mb={2}>
          Tupaantuliaisia vietettiin 5-7.10.1990. Juhlaan osallistui yli 300
          veteraania puolisoineen ja ystävineen. Kunniavieraina olivat Haaviston
          perheestä Jukka Haavisto ja Kaisa Ropponen. Jukka Haavisto muisteli
          lapsuus-ja nuoruusvuosiaan entisessä kodissaan. Hän esitti myös suuret
          kiitokset Kauhavan sotaveraaneille, jotka halusivat pelastaa ja
          säilyttää tämän poikkeuksellisissa olosuhteissa veistetyn talon. Se on
          kaikille jälkipolville osoitus siitä yksimielisyydestä ja
          yhteishengestä, joka sodan raskaina vuosina vallitsi kansamme
          keskuudessa. Niiden avulla suuretkin koettelemukset kestettiin. Siksi
          saamme kasvaa ja tehdä työtä vapaassa isänmaassa.
        </Text>
        <Heading fontSize='xl' mb={2} mt={4}>
          5. Nykyinen omistaja
        </Heading>
        <Text mb={2}>
          Talon valmistuttua tehtiin sopimus, että 25 vuoden kuluttua
          veteraanitalo siirtyy Kauhava-seuran omistukseen. Nyt tuo aika on
          kulunut ja talon omistaa ja sen käytöstä vastaa Kauhava-seura. Martti
          Mansikkamäen kertomuksen pohjalta lyhentänyt Seppo Ruotsala
        </Text>
      </Flex>
    </PageWrapper>
  )
}
export default HistoryPage
